import { useLocation } from "react-router-dom";

export function withRouter(Children) {
    return (props) => {
      return <Children {...props} report={useLocation().state} />;
    };
}

